import { LessonProgressStatus } from "models/LessonProgressStatus";
import { RewardType } from "models/RewardType";

export const isUncompleted = (status: LessonProgressStatus): boolean =>
    status !== LessonProgressStatus.Finished;

export const isPassedResult = (status: LessonProgressStatus, rewardType: RewardType): boolean =>
    status === LessonProgressStatus.Finished && rewardType !== RewardType.None;
